import { OccConfig, OccEndpoints } from '@spartacus/core';

export interface AtgOccEndpoints extends OccEndpoints {
  contactUs?: string;
}

export const atgOccEndpointsConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: <AtgOccEndpoints>{
        contactUs: 'contact-us',
      },
    },
  },
};
